import { createSelector } from 'reselect';

import getSelectedCity from './getSelectedCity';

const getSelectedCityDefaultArea = createSelector(
  getSelectedCity,
  city => city?.defaultArea,
);

export default getSelectedCityDefaultArea;
